import _ from 'lodash'

const unit = {
  // 对象拷贝
  cloneDeep: obj => {
    if (!obj) {
      return ''
    }
    return _.cloneDeep(obj)
  },
  // 判断是否空对象
  isEmptyObject: val => {
    let obj = unit.cloneDeep(val)
    delete obj._index
    delete obj._rowKey
    for (let key in obj) {
      return false
    }
    return true
  },
  // 时间加上隔开符 -
  dateFormat: val => {
    let time = String(val)
    if (time && time.length === 8) {
      let year = time.slice(0, 4)
      let month = time.slice(4, 6)
      let day = time.slice(6, 8)
      return year + '-' + month + '-' + day
    }
    return ''
  },
  strDate2Format (dateStr, format = 'yyyy-MM-dd') {
    if (dateStr === '' || dateStr === 'undefined') {
      return ''
    }
    const d = new Date(dateStr)
    let resDate = ''

    if (format === 'yyyy-MM-dd') {
      resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    } else if (format === 'yyyy-MM-dd hh:mm:ss') {
      resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    } else if (format === 'yyyyMMdd') {
      resDate = d.getFullYear() + '' + (d.getMonth() + 1) + '' + d.getDate()
    }
    return resDate
  },
  priceFormat (val, key, isAmt = false) {
    if (!val || val == '-' || val == '--') {
      return val
    }
    if (key === 'pxChangeRate') {
      return val
    }
    // 成交总量/现量格式化
    if (key === 'businessAmount' || key === 'currentAmount') {
      let ival = (val + '').length
      if (ival > 8) {
        return (val / 100000000).toFixed(2) + '亿'
      }
      if (ival > 4) {
        return (val / 10000).toFixed(2) + '万'
      }
      return isAmt ? val.toFixed(2) : val
    }
    // 成交总额格式化
    if (key === 'businessBalance') {
      // 处理小数点的情况
      let sval = val + ''
      if (sval.indexOf('.') > 0) {
        sval = sval.substring(0, sval.indexOf('.'))
      }
      let ival = sval.length
      if (ival > 8) {
        return (val / 100000000).toFixed(2) + '亿'
      }
      if (ival > 4) {
        return (val / 10000).toFixed(2) + '万'
      }
    }
    return Number(val).toFixed(2)
  }
}

export default unit
